module.exports = __webpack_public_path__ + "img/join_us_banner.08c353d7.webp";